import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/section'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(section) {
    return http.post(`${resource}`, section)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(section, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, section)
  },
}
